<template>
  <div class="acts common-bg"  v-if="activitytypeList.length > 0">
    <div class="flex-c-b" style="background: #292a2c;">
      <div class="back" @click="$router.back()">
        <van-icon name="arrow-left" color="#BEBEBE" size="16"/>
      </div>
      <van-tabs v-model="actType" class="topsa" background="#292A2C" title-active-color="#DFB372" title-inactive-color="#fff">
        <van-tab v-for="(item, index) in activitytypeList" :name="item.id" :title="item.name" :key="index"> </van-tab>
      </van-tabs>
    </div>

    <div class="consg-new" v-if="actType == '0'">
      <van-row>
        <van-col span="6">
          <div class="left">
            <div class="tab flex-c-c" v-for="(item,index) in leftTabsList" :key="index" @click="handleRadio(index)" :class="index == activeIndex?'active':''">
              <img v-if="index == activeIndex" src="/static/newImg/active/menu/xuanzhong_left.avif" class="tab-deco tab-deco-left" />
              <img :src="index == activeIndex ? item.iconActive : item.icon" class="tab-icon" />
              <span class="tab-name">{{ item.name }}</span>
              <img v-if="index == activeIndex" src="/static/newImg/active/menu/xuanzhong_right.avif" class="tab-deco tab-deco-right" />
            </div>
          </div>
          <div class="left-btn">
            <div class="b">领取记录</div>
            <div class="b"><van-icon name="replay" color="#DFB372" size="10" />刷新奖励</div>
          </div>
        </van-col>
        <van-col span="18">
          <div class="right">
            <div class="content" v-for="(item,index) in rightActiveList" :key="item.id" @click="goActivityDetail(item)">
              <van-image height="3.2rem" fit="contain" :src="item.img"/>
            </div>
          </div>
        </van-col>
      </van-row>
    </div>

    <div v-if="actType == '1'">
      <taskComponents></taskComponents>
    </div>

    <div v-if="actType == '2'">
      <svipComponents></svipComponents>
    </div>

    <div v-if="actType == '3'">
      <vipPageComponents></vipPageComponents>
    </div>

    <div v-if="actType == '4'">
      <fanshuiComponents></fanshuiComponents>
    </div>

    <div v-if="actType == '5'">
      <div class="pending-page">
        <div class="pending-list" v-if="pendingList.length > 0">
          <div class="pending-item" v-for="(item, index) in pendingList" :key="index">
            <div class="item-icon"><van-icon :name="item.icon" size="32" :color="item.color" /></div>
            <div class="item-info">
              <div class="item-title">{{ item.title }}</div>
              <div class="item-desc">{{ item.desc }}</div>
            </div>
            <van-button type="primary" class="btn-pending" @click="handlePending(index)">领取</van-button>
          </div>
        </div>
        <div class="pending-empty" v-else>
          <van-icon name="gift" size="64" color="#666" />
          <p>暂无待领取奖励</p>
        </div>
      </div>
    </div>

    <div v-if="actType == '6'">
      <lixibaoComponents></lixibaoComponents>
    </div>

    <div v-if="actType == '7'">
      <lingqujiluComponents></lingqujiluComponents>
    </div>

    <div v-if="actType == '8'">
      <gongjijinComponents></gongjijinComponents>
    </div>

    <div v-if="actType == '9'">
      <xingyunzhuanpanComponents></xingyunzhuanpanComponents>
    </div>
  </div>
</template>
<script>
import svipComponents from "../component/svip.vue"
import lixibaoComponents from "../component/lixibao.vue"
import fanshuiComponents from "../component/fanshui.vue"
import lingqujiluComponents from "../component/lingqujilu.vue"
import gongjijinComponents from "../component/gongjijin.vue"
import xingyunzhuanpanComponents from "../component/xingyunzhuanpan.vue"
import taskComponents from "../component/task.vue"
import vipPageComponents from "../component/vipPage.vue"
export default {
  name: 'activity',
  components: {
		svipComponents,
		lixibaoComponents,
		fanshuiComponents,
		lingqujiluComponents,
		gongjijinComponents,
		xingyunzhuanpanComponents,
		taskComponents,
		vipPageComponents,
	},
  data() {
    return {
      activitytypeList: [],
      actType: '0',
      activitylistList: [],
      activeIndex: 0,
      fanshuiPending: '0.00',
      fanshuiList: [],
      fanshuiActiveTab: 0,
      fanshuiTotalAmount: '0.00',
      fanshuiTabs: [
        { name: '电子', icon: '/static/newImg/static/active/icon8.avif' },
        { name: '棋牌', icon: '/static/newImg/static/active/icon9.avif' },
        { name: '捕鱼', icon: '/static/newImg/static/active/icon10.avif' },
        { name: '真人', icon: '/static/newImg/static/active/icon11.avif' },
        { name: '体育', icon: '/static/newImg/static/active/icon13.avif' },
        { name: '区块链', icon: '/static/newImg/static/active/icon12.avif' },
        { name: '电竞', icon: '/static/newImg/static/active/icon7.avif' },
      ],
      fanshuiRightList: [
        { icon: '/static/newImg/static/active/icon8.avif', name: '电子', betAmount: '0.00', rate: '0.00%', rebet: '再投注1.00%', pending: '0.00' },
        { icon: '/static/newImg/static/active/icon8.avif', name: '电子', betAmount: '0.00', rate: '0.00%', rebet: '再投注1.00%', pending: '0.00' },
        { icon: '/static/newImg/static/active/icon9.avif', name: '棋牌', betAmount: '0.00', rate: '0.00%', rebet: '再投注1.00%', pending: '0.00' },
        { icon: '/static/newImg/static/active/icon10.avif', name: '捕鱼', betAmount: '0.00', rate: '0.00%', rebet: '再投注1.00%', pending: '0.00' },
        { icon: '/static/newImg/static/active/icon11.avif', name: '真人', betAmount: '0.00', rate: '0.00%', rebet: '再投注1.00%', pending: '0.00' },
        { icon: '/static/newImg/static/active/icon11.avif', name: '真人', betAmount: '0.00', rate: '0.00%', rebet: '再投注1.00%', pending: '0.00' },
        { icon: '/static/newImg/static/active/icon12.avif', name: '区块链', betAmount: '0.00', rate: '0.00%', rebet: '再投注1.00%', pending: '0.00' },
        { icon: '/static/newImg/static/active/icon7.avif', name: '电竞', betAmount: '0.00', rate: '0.00%', rebet: '再投注1.00%', pending: '0.00' },
      ],
      pendingList: [],
      recordList: [],
      gongjijinAmount: '0.00',
      gongjijinTotal: '0.00',
      gongjijinWithdraw: '0.00',
      leftTabsList: [
        {'name': '综 合', 'id': '', icon: '/static/newImg/active/menu/icon_dtfl_zh_0.svg', iconActive: '/static/newImg/active/menu/icon_dtfl_zh_1.svg'},
        {'name': '新 人', 'id': '', icon: '/static/newImg/active/menu/icon_dtfl_xr_0.avif', iconActive: '/static/newImg/active/menu/icon_dtfl_xr_1.avif'},
        {'name': '钱 包', 'id': '', icon: '/static/newImg/active/menu/icon_dtfl_qb_0.avif', iconActive: '/static/newImg/active/menu/icon_dtfl_qb_1.avif'},
        {'name': '云股东', 'id': '', icon: '/static/newImg/active/menu/icon_dtfl_ygd_0.avif', iconActive: '/static/newImg/active/menu/icon_dtfl_ygd_1.avif'},
        {'name': '电 子', 'id': '', icon: '/static/newImg/active/menu/icon_dtfl_dz_0.svg', iconActive: '/static/newImg/active/menu/icon_dtfl_dz_1.svg'},
        {'name': '捕 鱼', 'id': '', icon: '/static/newImg/active/menu/icon_dtfl_by_0.svg', iconActive: '/static/newImg/active/menu/icon_dtfl_by_1.svg'},
        {'name': '棋 牌', 'id': '', icon: '/static/newImg/active/menu/icon_dtfl_qp_0.svg', iconActive: '/static/newImg/active/menu/icon_dtfl_qp_1.svg'},
        {'name': '真 人', 'id': '', icon: '/static/newImg/active/menu/icon_dtfl_zr_0.svg', iconActive: '/static/newImg/active/menu/icon_dtfl_zr_1.svg'},
        {'name': '区块链', 'id': '', icon: '/static/newImg/active/menu/icon_dtfl_qkl_0.svg', iconActive: '/static/newImg/active/menu/icon_dtfl_qkl_1.svg'},
        {'name': '体 育', 'id': '', icon: '/static/newImg/active/menu/icon_dtfl_ty_0.svg', iconActive: '/static/newImg/active/menu/icon_dtfl_ty_1.svg'},
        {'name': '新蒲京', 'id': '', icon: '/static/newImg/active/menu/icon_dtfl_xpj_0.avif', iconActive: '/static/newImg/active/menu/icon_dtfl_xpj_1.avif'},
      ],
      rightActiveList:[
        {id:'1',img:'/static/newImg/active/zonghe/zonghe_1.avif',template:'3'},
        {id:'72',img:'/static/newImg/active/zonghe/zonghe_72.avif',template:'4'},
        {id:'2',img:'/static/newImg/active/zonghe/zonghe_2.avif',template:'5'},
        {id:'3',img:'/static/newImg/active/zonghe/zonghe_3.avif',template:'1'},
        {id:'4',img:'/static/newImg/active/zonghe/zonghe_4.avif',template:'1'},
        {id:'5',img:'/static/newImg/active/zonghe/zonghe_5.avif',template:'1'},
        {id:'6',img:'/static/newImg/active/zonghe/zonghe_6.avif',template:'1'},
        {id:'7',img:'/static/newImg/active/zonghe/zonghe_7.avif',template:'5'},
        // {id:'8',img:'/static/newImg/active/zonghe/zonghe_8.avif',template:'1'},
        // {id:'9',img:'/static/newImg/active/zonghe/zonghe_9.avif',template:'1'},
        // {id:'10',img:'/static/newImg/active/zonghe/zonghe_10.avif',template:'1'},
        // {id:'11',img:'/static/newImg/active/zonghe/zonghe_11.avif',template:'1'},
        // {id:'12',img:'/static/newImg/active/zonghe/zonghe_12.avif',template:'1'},
        // {id:'13',img:'/static/newImg/active/zonghe/zonghe_13.avif',template:'1'},
        {id:'14',img:'/static/newImg/active/zonghe/zonghe_14.avif',template:'6'},
        {id:'15',img:'/static/newImg/active/zonghe/zonghe_15.avif',template:'1'},
        {id:'16',img:'/static/newImg/active/zonghe/zonghe_16.avif',template:'5'},
        {id:'17',img:'/static/newImg/active/zonghe/zonghe_17.avif',template:'1'},
        {id:'18',img:'/static/newImg/active/zonghe/zonghe_18.avif',template:'1'},
        {id:'19',img:'/static/newImg/active/zonghe/zonghe_19.avif',template:'1'},
        {id:'20',img:'/static/newImg/active/zonghe/zonghe_20.avif',template:'4'},
        {id:'21',img:'/static/newImg/active/zonghe/zonghe_21.avif',template:'1'},
        {id:'22',img:'/static/newImg/active/zonghe/zonghe_22.avif',template:'1'},
        {id:'23',img:'/static/newImg/active/zonghe/zonghe_23.avif',template:'4'},
        {id:'24',img:'/static/newImg/active/zonghe/zonghe_24.avif',template:'1'},
        {id:'25',img:'/static/newImg/active/zonghe/zonghe_25.avif',template:'1'},
        {id:'26',img:'/static/newImg/active/zonghe/zonghe_26.avif',template:'1'},
        {id:'27',img:'/static/newImg/active/zonghe/zonghe_27.avif',template:'1'},
        {id:'28',img:'/static/newImg/active/zonghe/zonghe_28.avif',template:'1'},
        {id:'29',img:'/static/newImg/active/zonghe/zonghe_29.avif',template:'1'},
        {id:'30',img:'/static/newImg/active/zonghe/zonghe_30.avif',template:'1'},
        {id:'31',img:'/static/newImg/active/zonghe/zonghe_31.avif',template:'1'},
        {id:'32',img:'/static/newImg/active/zonghe/zonghe_32.avif',template:'1'},
        {id:'33',img:'/static/newImg/active/zonghe/zonghe_33.avif',template:'1'},
        {id:'34',img:'/static/newImg/active/zonghe/zonghe_34.avif',template:'1'},
        {id:'35',img:'/static/newImg/active/zonghe/zonghe_35.avif',template:'1'},
        {id:'36',img:'/static/newImg/active/zonghe/zonghe_36.avif',template:'1'},
        {id:'37',img:'/static/newImg/active/zonghe/zonghe_37.avif',template:'1'},
        {id:'38',img:'/static/newImg/active/zonghe/zonghe_38.avif',template:'1'},
        {id:'39',img:'/static/newImg/active/zonghe/zonghe_39.avif',template:'1'},
        {id:'40',img:'/static/newImg/active/zonghe/zonghe_40.avif',template:'1'},
        {id:'41',img:'/static/newImg/active/zonghe/zonghe_41.avif',template:'1'},
        {id:'42',img:'/static/newImg/active/zonghe/zonghe_42.avif',template:'1'},
        {id:'43',img:'/static/newImg/active/zonghe/zonghe_43.avif',template:'1'},
        {id:'44',img:'/static/newImg/active/zonghe/zonghe_44.avif',template:'1'},
        {id:'45',img:'/static/newImg/active/zonghe/zonghe_45.avif',template:'1'},
        {id:'46',img:'/static/newImg/active/zonghe/zonghe_46.avif',template:'1'},
        {id:'47',img:'/static/newImg/active/zonghe/zonghe_47.avif',template:'1'},
        {id:'48',img:'/static/newImg/active/zonghe/zonghe_48.avif',template:'1'},
        {id:'49',img:'/static/newImg/active/zonghe/zonghe_49.avif',template:'1'},
        {id:'50',img:'/static/newImg/active/zonghe/zonghe_50.avif',template:'1'},
        {id:'51',img:'/static/newImg/active/zonghe/zonghe_51.avif',template:'1'},
        {id:'52',img:'/static/newImg/active/zonghe/zonghe_52.avif',template:'1'},
        {id:'53',img:'/static/newImg/active/zonghe/zonghe_53.avif',template:'1'},
        {id:'54',img:'/static/newImg/active/zonghe/zonghe_54.avif',template:'1'},
        {id:'55',img:'/static/newImg/active/zonghe/zonghe_55.avif',template:'1'},
        {id:'56',img:'/static/newImg/active/zonghe/zonghe_56.avif',template:'1'},
        {id:'57',img:'/static/newImg/active/zonghe/zonghe_57.avif',template:'1'},
        {id:'58',img:'/static/newImg/active/zonghe/zonghe_58.avif',template:'1'},
        {id:'59',img:'/static/newImg/active/zonghe/zonghe_59.avif',template:'1'},
        {id:'60',img:'/static/newImg/active/zonghe/zonghe_60.avif',template:'1'},
        {id:'61',img:'/static/newImg/active/zonghe/zonghe_61.avif',template:'1'},
        {id:'62',img:'/static/newImg/active/zonghe/zonghe_62.avif',template:'1'},
        {id:'63',img:'/static/newImg/active/zonghe/zonghe_63.avif',template:'1'},
        {id:'64',img:'/static/newImg/active/zonghe/zonghe_64.avif',template:'1'},
        {id:'65',img:'/static/newImg/active/zonghe/zonghe_65.avif',template:'1'},
        {id:'66',img:'/static/newImg/active/zonghe/zonghe_66.avif',template:'1'},
        {id:'67',img:'/static/newImg/active/zonghe/zonghe_67.avif',template:'1'},
        {id:'68',img:'/static/newImg/active/zonghe/zonghe_68.avif',template:'1'},
        {id:'69',img:'/static/newImg/active/zonghe/zonghe_69.avif',template:'1'},
        {id:'70',img:'/static/newImg/active/zonghe/zonghe_70.avif',template:'1'},
        {id:'71',img:'/static/newImg/active/zonghe/zonghe_71.avif',template:'1'},
      ]
    };
  },
  created() {
    let that = this;
    that.activitytype().then(() => {
      if (that.$route.query.tab) {
        let tabExists = that.activitytypeList.some(item => item.id === that.$route.query.tab);
        if (tabExists) {
          that.actType = that.$route.query.tab;
        }
      }
    });
  },
  activated() {
    // 从缓存恢复时检查URL参数
    let tab = this.$route.query.tab;
    if (tab && this.activitytypeList.some(item => item.id === tab)) {
      this.actType = tab;
    } else {
      this.actType = '0';
      this.activeIndex = 0;
    }
  },
  watch: {
    actType() {
      // 切换选项卡时清除URL上的tab参数
      if (this.$route.query.tab) {
        this.$router.replace({ path: '/activity', query: {} }).catch(() => {});
      }
    },
  },
  methods: {
    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
    activitytype() {
      let that = this;
      return that.$apiFun.post('/api/activitytype', {}).then(res => {
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          // that.activitytypeList = res.data;
          that.activitytypeList = [
            { name: '活动', id: '0' },
            { name: '任务', id: '1' },
            { name: '金融SVIP', id: '2' },
            { name: 'VIP', id: '3' },
            { name: '返水', id: '4' },
            { name: '待领取', id: '5' },
            { name: '利息宝', id: '6' },
            { name: '领取记录', id: '7' },
            { name: '公积金', id: '8' },
            { name: '幸运转盘', id: '9' },
          ];
        }
      });
    },
    handleActive(i){
      console.log(i,'ddd');
      this.actType = i;
    },
    activitylist() {
      let that = this;
      let info = that.actType == '' ? {} : { type: that.actType };
      that.$parent.showLoading();
      that.$apiFun.post('/api/activitylist', info).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.activitylistList = res.data.data;
        }
        that.$parent.hideLoading();
      });
    },
    changActType(val) {
      let that = this;
      if (val == that.actType) {
        return;
      }
      that.actType = val;
      that.activitylist();
    },
    handleRadio(index) {
      this.activeIndex = index;
      if(index == 0){
        this.rightActiveList=[
          {id:'1',img:'/static/newImg/active/zonghe/zonghe_1.avif',template:'3'},
          {id:'72',img:'/static/newImg/active/zonghe/zonghe_72.avif',template:'4'},
          {id:'2',img:'/static/newImg/active/zonghe/zonghe_2.avif',template:'5'},
          {id:'3',img:'/static/newImg/active/zonghe/zonghe_3.avif',template:'1'},
          {id:'4',img:'/static/newImg/active/zonghe/zonghe_4.avif',template:'1'},
          {id:'5',img:'/static/newImg/active/zonghe/zonghe_5.avif',template:'1'},
          {id:'6',img:'/static/newImg/active/zonghe/zonghe_6.avif',template:'1'},
          {id:'7',img:'/static/newImg/active/zonghe/zonghe_7.avif',template:'5'},
          // {id:'8',img:'/static/newImg/active/zonghe/zonghe_8.avif',template:'1'},
          // {id:'9',img:'/static/newImg/active/zonghe/zonghe_9.avif',template:'1'},
          // {id:'10',img:'/static/newImg/active/zonghe/zonghe_10.avif',template:'1'},
          // {id:'11',img:'/static/newImg/active/zonghe/zonghe_11.avif',template:'1'},
          // {id:'12',img:'/static/newImg/active/zonghe/zonghe_12.avif',template:'1'},
          // {id:'13',img:'/static/newImg/active/zonghe/zonghe_13.avif',template:'1'},
          {id:'14',img:'/static/newImg/active/zonghe/zonghe_14.avif',template:'6'},
          {id:'15',img:'/static/newImg/active/zonghe/zonghe_15.avif',template:'1'},
          {id:'16',img:'/static/newImg/active/zonghe/zonghe_16.avif',template:'5'},
          {id:'17',img:'/static/newImg/active/zonghe/zonghe_17.avif',template:'1'},
          {id:'18',img:'/static/newImg/active/zonghe/zonghe_18.avif',template:'1'},
          {id:'19',img:'/static/newImg/active/zonghe/zonghe_19.avif',template:'1'},
          {id:'20',img:'/static/newImg/active/zonghe/zonghe_20.avif',template:'4'},
          {id:'21',img:'/static/newImg/active/zonghe/zonghe_21.avif',template:'1'},
          {id:'22',img:'/static/newImg/active/zonghe/zonghe_22.avif',template:'1'},
          {id:'23',img:'/static/newImg/active/zonghe/zonghe_23.avif',template:'4'},
          {id:'24',img:'/static/newImg/active/zonghe/zonghe_24.avif',template:'1'},
          {id:'25',img:'/static/newImg/active/zonghe/zonghe_25.avif',template:'1'},
          {id:'26',img:'/static/newImg/active/zonghe/zonghe_26.avif',template:'1'},
          {id:'27',img:'/static/newImg/active/zonghe/zonghe_27.avif',template:'1'},
          {id:'28',img:'/static/newImg/active/zonghe/zonghe_28.avif',template:'1'},
          {id:'29',img:'/static/newImg/active/zonghe/zonghe_29.avif',template:'1'},
          {id:'30',img:'/static/newImg/active/zonghe/zonghe_30.avif',template:'1'},
          {id:'31',img:'/static/newImg/active/zonghe/zonghe_31.avif',template:'1'},
          {id:'32',img:'/static/newImg/active/zonghe/zonghe_32.avif',template:'1'},
          {id:'33',img:'/static/newImg/active/zonghe/zonghe_33.avif',template:'1'},
          {id:'34',img:'/static/newImg/active/zonghe/zonghe_34.avif',template:'1'},
          {id:'35',img:'/static/newImg/active/zonghe/zonghe_35.avif',template:'1'},
          {id:'36',img:'/static/newImg/active/zonghe/zonghe_36.avif',template:'1'},
          {id:'37',img:'/static/newImg/active/zonghe/zonghe_37.avif',template:'1'},
          {id:'38',img:'/static/newImg/active/zonghe/zonghe_38.avif',template:'1'},
          {id:'39',img:'/static/newImg/active/zonghe/zonghe_39.avif',template:'1'},
          {id:'40',img:'/static/newImg/active/zonghe/zonghe_40.avif',template:'1'},
          {id:'41',img:'/static/newImg/active/zonghe/zonghe_41.avif',template:'1'},
          {id:'42',img:'/static/newImg/active/zonghe/zonghe_42.avif',template:'1'},
          {id:'43',img:'/static/newImg/active/zonghe/zonghe_43.avif',template:'1'},
          {id:'44',img:'/static/newImg/active/zonghe/zonghe_44.avif',template:'1'},
          {id:'45',img:'/static/newImg/active/zonghe/zonghe_45.avif',template:'1'},
          {id:'46',img:'/static/newImg/active/zonghe/zonghe_46.avif',template:'1'},
          {id:'47',img:'/static/newImg/active/zonghe/zonghe_47.avif',template:'1'},
          {id:'48',img:'/static/newImg/active/zonghe/zonghe_48.avif',template:'1'},
          {id:'49',img:'/static/newImg/active/zonghe/zonghe_49.avif',template:'1'},
          {id:'50',img:'/static/newImg/active/zonghe/zonghe_50.avif',template:'1'},
          {id:'51',img:'/static/newImg/active/zonghe/zonghe_51.avif',template:'1'},
          {id:'52',img:'/static/newImg/active/zonghe/zonghe_52.avif',template:'1'},
          {id:'53',img:'/static/newImg/active/zonghe/zonghe_53.avif',template:'1'},
          {id:'54',img:'/static/newImg/active/zonghe/zonghe_54.avif',template:'1'},
          {id:'55',img:'/static/newImg/active/zonghe/zonghe_55.avif',template:'1'},
          {id:'56',img:'/static/newImg/active/zonghe/zonghe_56.avif',template:'1'},
          {id:'57',img:'/static/newImg/active/zonghe/zonghe_57.avif',template:'1'},
          {id:'58',img:'/static/newImg/active/zonghe/zonghe_58.avif',template:'1'},
          {id:'59',img:'/static/newImg/active/zonghe/zonghe_59.avif',template:'1'},
          {id:'60',img:'/static/newImg/active/zonghe/zonghe_60.avif',template:'1'},
          {id:'61',img:'/static/newImg/active/zonghe/zonghe_61.avif',template:'1'},
          {id:'62',img:'/static/newImg/active/zonghe/zonghe_62.avif',template:'1'},
          {id:'63',img:'/static/newImg/active/zonghe/zonghe_63.avif',template:'1'},
          {id:'64',img:'/static/newImg/active/zonghe/zonghe_64.avif',template:'1'},
          {id:'65',img:'/static/newImg/active/zonghe/zonghe_65.avif',template:'1'},
          {id:'66',img:'/static/newImg/active/zonghe/zonghe_66.avif',template:'1'},
          {id:'67',img:'/static/newImg/active/zonghe/zonghe_67.avif',template:'1'},
          {id:'68',img:'/static/newImg/active/zonghe/zonghe_68.avif',template:'1'},
          {id:'69',img:'/static/newImg/active/zonghe/zonghe_69.avif',template:'1'},
          {id:'70',img:'/static/newImg/active/zonghe/zonghe_70.avif',template:'1'},
          {id:'71',img:'/static/newImg/active/zonghe/zonghe_71.avif',template:'1'},
        ]
      }else if(index == 1){
        this.rightActiveList=[
          {id:'1',img:'/static/newImg/active/xinren/xinren_1.avif',template:'1'},
          {id:'2',img:'/static/newImg/active/xinren/xinren_2.avif',template:'1'},
          {id:'3',img:'/static/newImg/active/xinren/xinren_3.avif',template:'1'},
          {id:'4',img:'/static/newImg/active/xinren/xinren_4.avif',template:'1'},
          {id:'5',img:'/static/newImg/active/xinren/xinren_5.avif',template:'1'},
          {id:'6',img:'/static/newImg/active/xinren/xinren_6.avif',template:'1'},
        ]
      }else if(index == 2){
        this.rightActiveList=[
          {id:'1',img:'/static/newImg/active/qianbao/qianbao_1.avif',template:'1'},
          {id:'2',img:'/static/newImg/active/qianbao/qianbao_2.avif',template:'1'},
          {id:'3',img:'/static/newImg/active/qianbao/qianbao_3.avif',template:'1'},
          {id:'4',img:'/static/newImg/active/qianbao/qianbao_4.avif',template:'1'},
          {id:'5',img:'/static/newImg/active/qianbao/qianbao_5.avif',template:'1'},
          {id:'6',img:'/static/newImg/active/qianbao/qianbao_6.avif',template:'1'},
          {id:'7',img:'/static/newImg/active/qianbao/qianbao_7.avif',template:'1'},
          {id:'8',img:'/static/newImg/active/qianbao/qianbao_8.avif',template:'1'},
        ]
      }else if(index == 3){
        this.rightActiveList=[
          {id:'1',img:'/static/newImg/active/yungudong/yungudong_1.avif',template:'1'},
          {id:'2',img:'/static/newImg/active/yungudong/yungudong_2.avif',template:'1'},
          {id:'3',img:'/static/newImg/active/yungudong/yungudong_3.avif',template:'1'},
          {id:'4',img:'/static/newImg/active/yungudong/yungudong_4.avif',template:'1'},
        ]
      }else if(index == 4){
        this.rightActiveList=[
          {id:'1',img:'/static/newImg/active/dianzi/dianzi_1.avif',template:'1'},
          {id:'2',img:'/static/newImg/active/dianzi/dianzi_2.avif',template:'1'},
          {id:'3',img:'/static/newImg/active/dianzi/dianzi_3.avif',template:'1'},
          {id:'4',img:'/static/newImg/active/dianzi/dianzi_4.avif',template:'1'},
          {id:'5',img:'/static/newImg/active/dianzi/dianzi_5.avif',template:'1'},
        ]
      }else if(index == 5){
        this.rightActiveList=[
          {id:'1',img:'/static/newImg/active/buyu/buyu_1.avif',template:'1'},
          {id:'2',img:'/static/newImg/active/buyu/buyu_2.avif',template:'1'},
          {id:'3',img:'/static/newImg/active/buyu/buyu_3.avif',template:'1'},
        ]
      }else if(index == 6){
        this.rightActiveList=[
          {id:'1',img:'/static/newImg/active/qipai/qipai_1.avif',template:'1'},
          {id:'2',img:'/static/newImg/active/qipai/qipai_2.avif',template:'1'},
          {id:'3',img:'/static/newImg/active/qipai/qipai_3.avif',template:'1'},
        ]
      }else if(index == 7){
        this.rightActiveList=[
          {id:'1',img:'/static/newImg/active/zhenren/zhenren_1.avif',template:'1'},
          {id:'2',img:'/static/newImg/active/zhenren/zhenren_2.avif',template:'1'},
          {id:'3',img:'/static/newImg/active/zhenren/zhenren_3.avif',template:'1'},
          {id:'4',img:'/static/newImg/active/zhenren/zhenren_4.avif',template:'1'},
        ]
      }else if(index == 8){
        this.rightActiveList=[
          {id:'1',img:'/static/newImg/active/qukuailian/qukuailian_1.avif',template:'1'},
          {id:'2',img:'/static/newImg/active/qukuailian/qukuailian_2.avif',template:'1'},
          {id:'3',img:'/static/newImg/active/qukuailian/qukuailian_3.avif',template:'1'},
        ]
      }else if(index == 9){
        this.rightActiveList=[
          {id:'1',img:'/static/newImg/active/tiyu/tiyu_1.avif',template:'1'},
        ]
      }else if(index == 10){
        this.rightActiveList=[
          {id:'1',img:'/static/newImg/active/xinpuging/xinpuging_1.avif',template:'1'},
          {id:'2',img:'/static/newImg/active/xinpuging/xinpuging_2.avif',template:'1'},
          {id:'3',img:'/static/newImg/active/xinpuging/xinpuging_3.avif',template:'1'},
          {id:'4',img:'/static/newImg/active/xinpuging/xinpuging_4.avif',template:'1'},
        ]
      }else{
        this.rightActiveList=[]
      }
    },
    handleFanshui() {
      let that = this;
      if (parseFloat(that.fanshuiPending) <= 0) {
        that.$parent.showTost(0, '暂无待领取返水');
        return;
      }
      that.$parent.showLoading();
      that.$apiFun.post('/api/dofanshui', {}).then(res => {
        that.$parent.showTost(res.code == 200 ? 1 : 0, res.message);
        if (res.code == 200) {
          that.fanshuiPending = '0.00';
        }
        that.$parent.hideLoading();
      }).catch(() => {
        that.$parent.hideLoading();
      });
    },
    handleFanshuiAll() {
      this.$parent.showTost(1, '一键领取成功');
    },
    handlePending(index) {
      this.$parent.showTost(1, '领取成功');
      this.pendingList.splice(index, 1);
    },
    handleGongjijinIn() {
      this.$parent.showTost(0, '存入功能开发中');
    },
    handleGongjijinOut() {
      this.$parent.showTost(0, '提取功能开发中');
    },
    goActivityDetail(item) {
      this.$router.push({
        path: '/activityDetail',
        query: { template: item.template || '1', activity_id: item.id, from: 'activity' }
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
// @import '../../../static/css/dashboard-activity.b2be1233.css';
@import '../../../static/css/common.css';
.acts{
  min-height: 100vh;
  overflow: hidden;
}
.topsa {
  position: fixed;
  top: 0;
  right: 0;
  width: 92%;
  z-index: 200;

  :deep(.van-tabs__nav) {
    overflow: hidden;
    background: #292A2C !important;
  }

  :deep(.van-tabs__active-bar) {
    background: #DFB372 !important;
    height: 3px;
  }

  :deep(.van-tab) {
    color: #fff !important;
    font-size: 0.26rem;
  }

  :deep(.van-tab--active) {
    color: #DFB372 !important;
  }
}
.back{
  background: #292a2c;
  height: 44px;
  line-height: 55px;
  text-align: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 8%;
  z-index: 200;
}
.consg-new{width: calc(100% - 20px);color: #fff;margin-top: 44px;padding: 5px 10px 70px;
  .left{overflow-y: auto;position: fixed;height: 75vh;
    .tab{
      display: flex;
      align-items: center;
      gap: 0.1rem;
      padding: 0.15rem 0.2rem;
      background: #1a1a1a;
      border-radius: 0.15rem;
      cursor: pointer;
      transition: all 0.2s;
      position: relative;
      margin: 0.2rem 0;
      box-sizing: border-box;
      .tab-icon {
        width: 0.6rem;
        height: 0.6rem;
        flex-shrink: 0;
      }
      .tab-name {
        font-size: 0.35rem;
        color: #999;
        white-space: nowrap;
      }
      .tab-deco {
        position: absolute;
        width: 0.65rem;
        height: 0.65rem;
        flex-shrink: 0;
        z-index: 1;
      }
      .tab-deco-left {
        top: 0;
        left: 0.1rem;
      }
      .tab-deco-right {
        bottom: 0;
        right: 0.1rem;
      }
    }
    .active{
      background: url('/static/newImg/active/menu/xuanzhong_bg.avif') center/contain no-repeat;
      .tab-name {
        color: #d1ae52;
      }
    }
  }
  .left-btn{position: fixed;bottom: 70px;left: 20px;
    .b{
      height: .56rem;
      line-height: .56rem;
      width: 1.4rem;
      padding: 0 .05rem;
      font-size: .28rem;
      text-align: center;
      color: #DFB372;
      border: 1px solid #DFB372;
      border-radius: .1rem;
      margin-bottom: .2rem;
    }
  }
  .right{margin-top: 10px;overflow-y: auto;
    .content{margin-bottom: 10px;}
  }
}
.consg {
  padding: 40px 15px;
  .lis {
    margin-top: 20px;
    // -webkit-box-shadow: 0 2px 4px 0 rgb(255 255 255 / 10%);
    // box-shadow: 0 2px 4px 0 rgb(255 255 255 / 10%);
    // padding-bottom:10px;
    // border-bottom: 1px solid #3b3c3d;
     img {
      width: 100%;
      border-radius: 15px;
    }
    img {
      width: 100%;
      border-radius: 10px;
    }
    .tite_sf {
      font-size: 12px;
      font-weight: 700;
      color: #fff;
      height: 30px;
      line-height: 30px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      box-sizing: border-box;
      padding: 0 20px;
    }
  }
}

.task-page, .vip-page, .pending-page, .record-page, .gongjijin-page, .turntable-page {
  margin-top: 44px;
  padding: 0.3rem;
  min-height: 80vh;
}

.task-empty, .vip-empty, .fanshui-empty, .pending-empty, .record-empty {
  text-align: center;
  padding: 3rem 0;
  color: #666;
  p {
    margin-top: 0.2rem;
    font-size: 0.3rem;
  }
}

.fanshui-header {
  background: linear-gradient(180deg, #292A2C 0%, #1E1F24 100%);
  padding: 0.5rem;
  border-radius: 0.2rem;
  text-align: center;
  margin-bottom: 0.3rem;
  .fanshui-title {
    font-size: 0.4rem;
    color: #fff;
    margin-bottom: 0.2rem;
  }
  .fanshui-rate {
    font-size: 0.28rem;
    color: #888;
  }
  .fanshui-rate-value {
    font-size: 0.5rem;
    font-weight: bold;
    color: #DFB372;
    margin-top: 0.1rem;
    display: block;
  }
}

.fanshui-pending {
  background: #292A2C;
  border-radius: 0.2rem;
  padding: 0.4rem;
  margin-bottom: 0.3rem;
  border: 1px solid #3B3C3D;
  .pending-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .pending-label {
      font-size: 0.3rem;
      color: #888;
    }
    .pending-amount {
      font-size: 0.5rem;
      font-weight: bold;
      color: #DFB372;
    }
    .btn-fanshui {
      background: linear-gradient(90deg, #DFB372 0%, #FFD700 100%);
      color: #1E1F24;
      font-weight: bold;
      border-radius: 0.4rem;
      height: 0.7rem;
      line-height: 0.7rem;
      font-size: 0.3rem;
      padding: 0 0.4rem;
    }
  }
}

.redirect-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60vh;

  p {
    margin-top: 0.3rem;
    font-size: 0.3rem;
    color: #888;
  }
}

.fanshui-list {
  background: #292A2C;
  border-radius: 0.2rem;
  overflow: hidden;
  .list-header {
    display: flex;
    padding: 0.3rem;
    background: #1E1F24;
    font-size: 0.28rem;
    color: #888;
    border-bottom: 1px solid #3B3C3D;
    .col-date { flex: 1; }
    .col-type { flex: 1; text-align: center; }
    .col-amount { flex: 1; text-align: right; }
  }
  .list-item {
    display: flex;
    padding: 0.3rem;
    border-bottom: 1px solid #3B3C3D;
    font-size: 0.28rem;
    color: #fff;
    .col-date { flex: 1; color: #888; }
    .col-type { flex: 1; text-align: center; }
    .col-amount { 
      flex: 1; 
      text-align: right;
      &.income { color: #3CC82F; }
      &.expense { color: #FD5A70; }
    }
  }
}

.pending-page {
  .pending-list {
    .pending-item {
      background: #292A2C;
      border-radius: 0.2rem;
      padding: 0.3rem;
      margin-bottom: 0.3rem;
      border: 1px solid #3B3C3D;
      display: flex;
      align-items: center;
      .item-icon {
        margin-right: 0.2rem;
      }
      .item-info {
        flex: 1;
        .item-title {
          font-size: 0.35rem;
          color: #fff;
          margin-bottom: 0.05rem;
        }
        .item-desc {
          font-size: 0.25rem;
          color: #888;
        }
      }
      .btn-pending {
        background: linear-gradient(90deg, #DFB372 0%, #FFD700 100%);
        color: #1E1F24;
        font-weight: bold;
        border-radius: 0.4rem;
        height: 0.6rem;
        line-height: 0.6rem;
        font-size: 0.25rem;
        padding: 0 0.3rem;
      }
    }
  }
}

.record-page {
  .record-list {
    .record-item {
      background: #292A2C;
      border-radius: 0.2rem;
      padding: 0.3rem;
      margin-bottom: 0.3rem;
      border: 1px solid #3B3C3D;
      display: flex;
      align-items: center;
      .record-icon {
        margin-right: 0.2rem;
      }
      .record-info {
        flex: 1;
        .record-title {
          font-size: 0.35rem;
          color: #fff;
          margin-bottom: 0.05rem;
        }
        .record-time {
          font-size: 0.25rem;
          color: #888;
        }
      }
      .record-amount {
        font-size: 0.35rem;
        font-weight: bold;
        &.income { color: #3CC82F; }
        &.expense { color: #FD5A70; }
      }
    }
  }
}

.gongjijin-page {
  .gongjijin-header {
    background: linear-gradient(180deg, #292A2C 0%, #1E1F24 100%);
    padding: 0.5rem;
    border-radius: 0.2rem;
    text-align: center;
    margin-bottom: 0.3rem;
    .gongjijin-title {
      font-size: 0.4rem;
      color: #fff;
      margin-bottom: 0.2rem;
    }
    .gongjijin-amount {
      font-size: 0.8rem;
      font-weight: bold;
      color: #DFB372;
    }
  }
  .gongjijin-content {
    background: #292A2C;
    border-radius: 0.2rem;
    padding: 0.4rem;
    border: 1px solid #3B3C3D;
    .content-item {
      display: flex;
      justify-content: space-between;
      padding: 0.2rem 0;
      border-bottom: 1px solid #3B3C3D;
      &:last-of-type {
        border-bottom: none;
      }
      .item-label {
        font-size: 0.3rem;
        color: #888;
      }
      .item-value {
        font-size: 0.3rem;
        color: #fff;
      }
    }
    .btn-group {
      display: flex;
      justify-content: center;
      gap: 0.3rem;
      margin-top: 0.4rem;
      .btn-gongjijin {
        width: 40%;
        height: 0.8rem;
        line-height: 0.8rem;
        font-size: 0.35rem;
        border-radius: 0.4rem;
      }
    }
  }
}

.turntable-page {
  .turntable-bg {
    background: linear-gradient(180deg, #292A2C 0%, #1E1F24 100%);
    padding: 2rem 0.5rem;
    border-radius: 0.2rem;
    text-align: center;
    .turntable-title {
      font-size: 0.4rem;
      color: #fff;
      margin-bottom: 1rem;
    }
    .turntable-empty {
      color: #888;
      p {
        margin-top: 0.3rem;
        font-size: 0.3rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mode/activity.vue